'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { AgencyHeader } from './header';
import { AgencyFooter } from './footer';
import { usePathname } from 'next/navigation';
import { AuthProvider } from '@/doi-tac-module/contexts/AuthContext';
import { LanguageProvider } from '@/doi-tac-module/contexts/LanguageContext';
import { NavigationProvider } from '@/doi-tac-module/contexts/NavigationContext';
import { UserProfile } from '@/doi-tac-module/lib/types';

const AgencyDebugWidget = dynamic(
  () => import('@/doi-tac-module/components/agency-debug-widget').then(mod => mod.AgencyDebugWidget),
  { ssr: false }
);

export default function AgencyLayoutClient({
  children,
  serverUser
}: {
  children: React.ReactNode;
  serverUser: UserProfile | null;
}) {
  const pathname = usePathname();
  const isPosterPage = pathname?.includes('/doi-tac/poster/');

  return (
    <LanguageProvider>
      <NavigationProvider>
        <AuthProvider serverUser={serverUser}>
        <div className="min-h-screen flex flex-col">
          {!isPosterPage && <AgencyHeader />}
          <main className="flex-1">
            {children}
          </main>
          {!isPosterPage && <AgencyFooter />}
          {process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev' && <AgencyDebugWidget />}
        </div>
      </AuthProvider>
    </NavigationProvider>
  </LanguageProvider>
  );
}
